import React, { useState, useEffect, Fragment } from 'react';
// import './MainContent.css';
import HomePage from './Sections/HomePage';
import SecondPage from './Sections/SecondPage';
import OrderModal from './Modals/OrderModal';
import SuccessModal from './Modals/SuccessModal';
import EighthPage from './Sections/eighthpage';
import ThirdPage from './Sections/thirdpage';
import FourthPage from './Sections/fourthpage';
import FifthPage from './Sections/fifthpage';
import SixthPage from './Sections/sixthpage';
import SeventhPage from './Sections/seventhpage';

const MainContent = () => {
  const [currentSection, setCurrentSection] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[id^="page-section-"]');
      const scrollPosition = window.scrollY + window.innerHeight / 2;

      sections.forEach((section, index) => {
        const sectionTop = section.offsetTop;
        const sectionBottom = sectionTop + section.offsetHeight;

        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          setCurrentSection(index);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDotClick = (sectionIndex) => {
    setCurrentSection(sectionIndex);
    const section = document.getElementById(`page-section-${sectionIndex}`);
    if (section) {
      section.scrollIntoView({ 
        behavior: 'smooth',
        // block: 'start'
      });
    }
  };

  const sections = [
    { id: 'page-section-0', component: <HomePage /> },
    { id: 'page-section-1', component: <SecondPage /> },
    { id: 'page-section-2', component: <ThirdPage /> },
    { id: 'page-section-3', component: <FourthPage /> },
    { id: 'page-section-4', component: <FifthPage /> },
    { id: 'page-section-5', component: <SixthPage /> },
    { id: 'page-section-6', component: <SeventhPage /> },
    { id: 'page-section-7', component: <EighthPage /> },
  ];

  return (
    <>
      <div className="dot-navigation">
        {sections.map((_, index) => (
          <div
            key={index}
            className={`dot ${currentSection === index ? 'active' : ''}`}
            data-section={index}
            onClick={() => handleDotClick(index)}
          ></div>
        ))}
      </div>
      {sections.map((section, index) => (
        <div key={index} id={section.id} style={{ padding: '0rem' }}>
          {section.component}
        </div>
      ))}
      {/* Modals */}
      <OrderModal />
      <SuccessModal />
    </>
  );
};

export default MainContent; 